import React, { useState, useMemo } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

import { delayCardOptions } from 'constants/automation';
import { formatDelay } from 'modules/automation/utils/formatDelay';
import { calculateTotalDelay } from 'modules/automation/utils/calculateTotalDelay';

export default function DelaySubCard({ index }) {
  const { control, setValue } = useFormContext();
  const actions = useWatch({ name: 'actions', control });

  const totalDelay = useMemo(() => calculateTotalDelay(actions, index), [actions, index]);

  const clearDelay = () => {
    setValue(`actions.${index}.delay`, null, { shouldValidate: true });
  };

  const addDelay = () => {
    setValue(`actions.${index}.delay`, { value: 0, delayUnit: 'minutes', show: true }, { shouldValidate: true });
  };

  const showDelay = useWatch({ name: `actions.${index}.delay.show`, control });

  return (
    <div className="time-delay-section mb-2">
      <div className="d-flex justify-content-between">
        <label htmlFor="timeDelay" className="form-label mb-0">
          <i className="fas fa-clock text-primary me-1"></i> Time Delay for this Action
        </label>
        {showDelay && (
          <Button
            tooltip="Remove"
            tooltipOptions={{ showDelay: 500 }}
            icon="pi pi-times danger-text"
            className="p-button-rounded p-button-text text-danger"
            onClick={clearDelay}
          />
        )}
      </div>
      {!showDelay ? (
        <Button
          icon="pi pi-plus"
          label="Add Time Delay"
          style={{ width: '150px', justifyContent: 'center', height: '35px' }}
          onClick={addDelay}
          className="p-button-primary p-button-sm mt-2"
        />
      ) : (
        <div className="row g-2 align-items-center mb-2">
          <div className="col-auto">
            <Controller
              name={`actions.${index}.delay.value`}
              control={control}
              defaultValue={0}
              render={({ field }) => (
                <InputNumber
                  name={field.name}
                  onChange={(e) => field.onChange(e.value)}
                  value={field.value}
                  style={{ width: '100px' }}
                  min={0}
                />
              )}
            />
          </div>
          <div className="col-auto">
            <Controller
              name={`actions.${index}.delay.delayUnit`}
              defaultValue="minutes"
              control={control}
              render={({ field }) => (
                <Dropdown
                  name={field.name}
                  value={field.value}
                  options={delayCardOptions}
                  onChange={(e) => field.onChange(e.value)}
                  style={{ width: '120px' }}
                  inputRef={field.ref}
                />
              )}
            />
          </div>
        </div>
      )}
      {showDelay && (
        <>
          {totalDelay > 0 ? (
            <div className="info-box text-primary mt-2">
              Based on your selections, this action will execute <strong>{formatDelay(totalDelay)}</strong> after the trigger.
            </div>
          ) : (
            <div className="info-box text-muted mt-2">
              Based on your selections, this action will execute immediately after the trigger.
            </div>
          )}
        </>
      )}
    </div>
  );
}
